import type { ButtonHTMLAttributes, ComponentProps, FC } from 'react';
import { useTranslations } from 'next-intl';
import ArrowNext from '@engineering/icons/arrow-next';
import ArrowLast from '@engineering/icons/arrow-last';

type CustomMonthButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: FC<ComponentProps<typeof ArrowNext | typeof ArrowLast>>;
  title: 'nextMonth' | 'previousMonth';
};

const CustomMonthButton = ({
  icon: Icon,
  title,
  ...props
}: CustomMonthButtonProps) => {
  const t = useTranslations('entities.datePicker');
  return (
    <button type="button" {...props} aria-label={t(title)}>
      <Icon width={24} height={24} />
    </button>
  );
};

export const CustomNextMonthButton = (
  props: ButtonHTMLAttributes<HTMLButtonElement>,
) => <CustomMonthButton {...props} icon={ArrowNext} title="nextMonth" />;

export const CustomPreviousMonthButton = (
  props: ButtonHTMLAttributes<HTMLButtonElement>,
) => <CustomMonthButton {...props} icon={ArrowLast} title="previousMonth" />;
